import { render } from "./CheckMultipleAnswers.vue?vue&type=template&id=31dcd89d"
import script from "./CheckMultipleAnswers.vue?vue&type=script&lang=js"
export * from "./CheckMultipleAnswers.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['render',render]])